import { MenuEntryWithCounter } from '@addins/media';
import { MediaMessagesViewComponent } from '../views/media-messages-view/media-messages-view.component';

export class MessagesMenuEntry extends MenuEntryWithCounter {
  constructor() {
    super('Messages', 'chatbubbles', MediaMessagesViewComponent, 410);
  }
}
